import { useTransition } from '../context/TransitionContext'

function Header() {
  const { triggerTransition } = useTransition()

  const handleContactClick = () => {
    triggerTransition('/contact', 'contact')
  }

  const handleHomeClick = () => {
    triggerTransition('/', 'home')
  }

  return (
    <div className="flex justify-center absolute w-full">
      <div className="w-full max-w-[87rem] py-8 flex px-4 justify-between items-center">
        <button
          className="text-2xl font-semibold"
          onClick={handleHomeClick}
        >
          portfolio.
        </button>

        <button
          onClick={handleContactClick}
          className="text-md hover:opacity-70 transition-opacity bg-white px-8 py-4 rounded-md font-semibold border-2 border-gray-200"
        >
          Hit me up
        </button>
      </div>
    </div>
  )
}

export default Header
